import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { getItem, removeItem } from '@/utils/storage.js'
import { convertToLocale } from '@/utils/helpers'

export function useFundModal() {
    const store = useStore()

    const showFundModal = ref(false)
    const fundSubTitle = ref('')
    const fundForm = ref('fundOptionsForm')
    const swapCurrency = ref('')
    const fundPayload = ref({})
    const fundOptions = ref('')
    const isAllowed = ref(false)

    const currency = computed(() => store.state.organisationModule.currency)
    const entityCard = computed(() => store.state.organisationModule.entityCard)
    const fundMethod = computed(() => store.state.organisationModule.fundMethod)
    const virtualAccount = computed(() => store.getters['organisationModule/virtualAccount'])

    const getProvider = computed(() => {
        let provider = null
        switch (currency.value) {
            case 'USD':
            case 'GBP':
            case 'EUR':
                provider = 'flutterwave'
                break
            case 'NGN':
            default:
                provider = 'transactpay'
                break
        }
        return provider
    })

    const openFundModal = () => {
        showFundModal.value = true
        fundForm.value = 'fundOptionsForm'
        fundSubTitle.value = 'How do you want to fund your wallet?'
    }

    const closeFundModal = () => {
        showFundModal.value = false
        removeItem('fundPayload')
        resetFundState()
    }

    const resetFundState = () => {
        fundForm.value = 'fundOptionsForm'
        fundSubTitle.value = ''
        swapCurrency.value = ''
        fundPayload.value = {}
        fundOptions.value = ''
    }

    const switchFundForm = async (form) => {
        const fundDetails = getItem('fundPayload')

        switch (form) {
            case 'Fund with bank transfer':
                fundForm.value = 'fundAmountForm'
                fundSubTitle.value = 'How much do you want to fund?'
                fundOptions.value = 'Fund with bank transfer'
                break
                
            case "Crypto":
                fundForm.value = "fundAmountForm";
                fundSubTitle.value = "How much do you want to fund?";
                fundOptions.value = "Crypto";
                break;

            case 'Fund with debit card':
                fundForm.value = 'fundAmountForm'
                fundSubTitle.value = 'How much do you want to fund?'
                fundOptions.value = 'Fund with debit card'
                break

            case 'P2P Transfers':
                fundForm.value = 'fundAmountForm'
                fundSubTitle.value = 'How much do you want to fund?'
                fundOptions.value = 'P2P Transfers'
                break

            // case 'Bank or Card':
            //     fundForm.value = 'fundAmountForm'
            //     fundSubTitle.value = 'How much do you want to fund?'
            //     fundOptions.value = 'Bank or Card'
            //     break

            case 'CardOptions':
                fundForm.value = 'fundConfirmationForm'
                fundSubTitle.value = 'Payment Confirmation'
                break

            case 'storedCard':
                fundForm.value = 'fundConfirmationForm'
                fundSubTitle.value = 'Payment Confirmation'
                fundOptions.value = 'Fund with stored card'
                break

            case 'newCard':
                fundForm.value = 'fundConfirmationForm'
                fundSubTitle.value = 'Payment Confirmation'
                fundOptions.value = 'Fund with Cash'
                break

            case 'fundAmountForm':
                if (entityCard.value.length === 0) {
                    fundForm.value = 'fundConfirmationForm'
                    fundSubTitle.value = 'Payment Confirmation'
                } else {
                    fundForm.value = 'CardOptions'
                    fundSubTitle.value = 'Select Debit Card'
                }
                break

            case 'fundConfirmationForm':
                const payload = {
                    currency: currency.value,
                    provider: getProvider.value,
                }

                if (fundOptions.value === 'Fund with bank transfer') {
                    const response = await store.dispatch('organisationModule/generateVirtualAccount', payload)
                    if (response) {
                        fundForm.value = 'DedicatedVirtualAccountForm'
                        fundSubTitle.value = `<p class="tw-text-gray-lightest3">Transfer a total amount of <span class='tw-text-primary tw-font-bold'>${currency.value} ${convertToLocale(fundDetails.totalAmount)}</span> to this account to fund your wallet.</p>`
                    }
                    return
                }

                if (virtualAccount.value.account_number && fundMethod.value === 'virtual') {
                    fundForm.value = 'DedicatedVirtualAccountForm'
                    fundSubTitle.value = `<p class="tw-text-gray-lightest3">Transfer a total amount of <span class='tw-text-primary tw-font-bold'>${currency.value} ${convertToLocale(fundDetails.totalAmount)}</span> to this account to fund your wallet.</p>`
                }

                if (fundMethod.value === 'fiat') {
                    fundForm.value = 'SelectDebitCardForm'
                    fundSubTitle.value = `Select card to fund <span class='tw-text-primary tw-font-bold'>${currency.value} ${convertToLocale(fundDetails.totalAmount)}</span> with`
                }
                break

            case 'Another wallet':
                fundForm.value = 'walletList'
                fundSubTitle.value = 'Where would you like to convert from?'
                break

            case 'fundWalletList':
                fundForm.value = 'fundAmountForm'
                fundSubTitle.value = 'How much do you want to convert?'
                fundOptions.value = `${swapCurrency.value} Wallet`
                break
        }
    }

    const goBackFund = (form) => {
        const fundDetails = getItem('fundPayload')

        console.log(form, "form")

        switch (form) {
            case 'SelectCurrencyForm':
                fundForm.value = 'fundOptionsForm'
                fundSubTitle.value = 'How do you want to fund your wallet'
                break

            case 'fundAmountForm':
                fundForm.value = 'fundOptionsForm'
                fundSubTitle.value = 'How do you want to fund your wallet?'
                break

            case 'fundConfirmationForm':
                fundForm.value = 'fundAmountForm'
                fundSubTitle.value = 'How much do you want to fund?'
                break

            case 'DedicatedVirtualAccountForm':
                fundForm.value = 'fundConfirmationForm'
                fundSubTitle.value = `<p class="tw-text-gray-lightest3">Transfer a total amount of <span class='tw-text-primary tw-font-bold'>${currency.value} ${convertToLocale(fundDetails.totalAmount)}</span> to this account to fund your wallet.</p>`
                break

            case 'CardOptions':
                fundForm.value = 'fundAmountForm'
                fundSubTitle.value = 'How much do you want to fund?'
                break
            case 'Another wallet':
                fundForm.value = 'walletList'
                fundSubTitle.value = 'How much do you want to fund?'
                break
            case 'walletList':
                fundForm.value = 'fundOptionsForm'
                fundSubTitle.value = 'How much do you want to fund?'
                break
        }
    }

    const fundFromWallet = (selectedCurrency) => {
        swapCurrency.value = selectedCurrency
        switchFundForm('fundWalletList')
    }

    const refreshFund = () => {
        fundForm.value = 'fundOptionsForm'
        fundSubTitle.value = 'How do you want to fund your wallet'
    }

    return {
        showFundModal,
        fundSubTitle,
        fundForm,
        swapCurrency,
        fundPayload,
        fundOptions,
        isAllowed,
        currency,
        entityCard,
        fundMethod,
        virtualAccount,
        getProvider,
        openFundModal,
        closeFundModal,
        switchFundForm,
        goBackFund,
        fundFromWallet,
        refreshFund,
        resetFundState
    }
}